// extracted by mini-css-extract-plugin
export default {"label":"LineChartEvent_label__y2nZS","wrapper":"LineChartEvent_wrapper__SdiLb","wrapperActive":"LineChartEvent_wrapperActive__1wPA0"};